// @flow

import type { Effect } from "../../types";

import { call, put, take } from "redux-saga/effects";
import { actions as routerActions } from "redux-router5";

import { gbiProjectActions } from "../actions";
import { createUserData } from "../../../api/createUserData";
import { getUser } from "../../../api/getUser";

export function* registerEffect(): Effect {
  while (true) {
    const {
      payload: { name, dogName, age, sex, breed, houseNo, villageNo, lane, road, subDistrict, district, province, zipcode, tel, email, },
      } = yield take(gbiProjectActions.register.id);
    yield put(gbiProjectActions.setLoading(true));
    try {
      const user = yield call (getUser, tel, email)
      console.log("resukt", email, user)
      if (user) {
         yield put(gbiProjectActions.setError("User alewady register"));
      } else {
             const isRegistered = yield call(
        createUserData,
        name,
        dogName,
        age,
        sex,
        breed,
        houseNo,
        villageNo,
        lane,
        road,
        subDistrict,
        district,
        province,
        zipcode,
        tel,
        email
      );
      yield put(routerActions.navigateTo('register-success'))
      }
    } catch (error) {
      console.log("error", error)
      yield put(gbiProjectActions.setError(error.code));
    }
    yield put(gbiProjectActions.setLoading(false));
  }
}
